import { InjectionToken } from '@angular/core';
import { UiConfig } from './ui.interface';

export const UI_CONFIG = new InjectionToken<UiConfig>('UiConfig');



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/de/webapp/src/app/@shared/ui/ui.config.ts